import { Card, Heading, Text } from "@/design-system";
import { PageSection } from "@/pages/landingPage/components/pageSection";

type NumberedStepsProps = {
  id: string;
  title: string;
  lead?: string;
  steps: { title: string; text: string }[];
};

export const NumberedSteps = ({
  id,
  title,
  lead,
  steps,
}: NumberedStepsProps) => (
  <PageSection labelledBy={`${id}-title`}>
    {/* scroll-mt: o link "Ver como funciona" do hero cai aqui sem ficar
        escondido atrás do header fixo. */}
    <div id={id} className="mb-8 flex scroll-mt-28 flex-col gap-3 lg:mb-10">
      <Heading level={2} id={`${id}-title`}>
        {title}
      </Heading>
      {lead ? (
        <Text size="lead" tone="muted" className="max-w-2xl">
          {lead}
        </Text>
      ) : null}
    </div>

    <ol className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
      {steps.map((step, index) => (
        <li key={step.title} className="flex">
          <Card className="flex w-full flex-col gap-3">
            <span
              aria-hidden="true"
              className="bg-ds-brand-600 text-ds-on-solid font-ds-sans text-ds-body flex size-10 items-center justify-center rounded-full font-semibold"
            >
              {index + 1}
            </span>
            <Heading level={3} size={4}>
              {step.title}
            </Heading>
            <Text tone="muted">{step.text}</Text>
          </Card>
        </li>
      ))}
    </ol>
  </PageSection>
);
